import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const modules = [{
  id: '01',
  title: 'Fundamentos de la Piel y Cosmetología',
  desc: 'Bases teóricas esenciales, tipos de piel, afecciones comunes y preparación del lienzo facial.'
}, {
  id: '02',
  title: 'Anatomía Facial y Zonas Seguras',
  desc: 'Estudio detallado de la musculatura facial, nervios, vasos sanguíneos y mapeo de seguridad.'
}, {
  id: '03',
  title: 'Tratamientos Cosméticos Paso a Paso',
  desc: 'Técnicas profesionales, productos recomendados y protocolos seguros para resultados visibles.'
}, {
  id: '04',
  title: 'Protocolos Profesionales',
  desc: 'Guías paso a paso para tratamientos específicos, desde la limpieza hasta el post-cuidado.'
}, {
  id: '05',
  title: 'Consulta y Manejo de Clientas',
  desc: 'Cómo realizar una evaluación inicial, consentimientos informados y manejo de expectativas.'
}, {
  id: '06',
  title: 'Cómo Crear tu Negocio Rentable',
  desc: 'Estructura de costos, fijación de precios premium, aspectos legales y mentalidad empresarial.'
}];
export const Modules = () => {
  return <section className="py-16 bg-base relative overflow-hidden" data-id="element-175">
      {/* decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-radial-fuchsia opacity-30 pointer-events-none" data-id="element-176" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-radial-glow opacity-40 pointer-events-none" data-id="element-177" />

      <div className="container mx-auto px-6 max-w-7xl relative z-10" data-id="element-178">
        <div className="text-center mb-12" data-id="element-179">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-pink-light border border-pink-medium text-fuchsia-dark text-xs font-semibold tracking-wider mb-4" data-id="element-180">
            <Sparkles className="w-3 h-3 text-gold" data-id="element-181" />
            6 MÓDULOS PREMIUM
            <Sparkles className="w-3 h-3 text-gold" data-id="element-182" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main mb-3" data-id="element-183">
            El temario más{' '}
            <span className="text-fuchsia italic" data-id="element-184">completo del mercado</span>
          </h2>
          <p className="text-text-muted max-w-xl mx-auto" data-id="element-185">
            Diseñado para llevarte de cero a experta, sin abrumarte.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-186">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} whileHover={{
          y: -6
        }} className="relative group cursor-default" data-id="element-187">
              {/* Soft glow on hover */}
              <div className="absolute -inset-0.5 bg-gradient-to-br from-fuchsia/30 via-gold/20 to-fuchsia/30 rounded-2xl opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-500" data-id="element-188" />

              <div className="relative bg-white rounded-2xl p-6 border border-pink-light shadow-sm group-hover:shadow-glow transition-all duration-300 h-full flex flex-col overflow-hidden" data-id="element-189">
                {/* Top accent bar */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-fuchsia via-gold to-fuchsia" data-id="element-190" />

                {/* Decorative corner ornament */}
                <div className="absolute -top-8 -right-8 w-20 h-20 bg-gradient-to-br from-pink-light to-transparent rounded-full opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-191" />

                {/* Number badge */}
                <div className="relative flex items-center justify-between mb-4" data-id="element-192">
                  <div className="relative" data-id="element-193">
                    <div className="absolute inset-0 bg-gradient-fuchsia rounded-xl blur-md opacity-40" data-id="element-194" />
                    <div className="relative w-12 h-12 bg-gradient-to-br from-fuchsia to-fuchsia-dark rounded-xl flex items-center justify-center shadow-glow" data-id="element-195">
                      <span className="text-white font-serif font-bold text-lg" data-id="element-196">
                        {mod.id}
                      </span>
                    </div>
                  </div>
                  <div className="text-[10px] font-bold text-gold-dark tracking-widest uppercase bg-gold/10 px-2.5 py-1 rounded-full border border-gold/20" data-id="element-197">
                    Módulo
                  </div>
                </div>

                <h3 className="text-base font-serif font-bold text-text-main mb-2 group-hover:text-fuchsia transition-colors relative" data-id="element-198">
                  {mod.title}
                </h3>
                <p className="text-sm text-text-muted leading-snug relative" data-id="element-199">
                  {mod.desc}
                </p>

                {/* Bottom accent dot row */}
                <div className="flex gap-1 mt-4 pt-4 border-t border-pink-light/60" data-id="element-200">
                  <div className="w-1.5 h-1.5 rounded-full bg-fuchsia" data-id="element-201" />
                  <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-202" />
                  <div className="w-1.5 h-1.5 rounded-full bg-pink-medium" data-id="element-203" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};